import { createDateFrom } from '@shared/utils/transform-date-funcs/transform-date-funcs';

export interface JsonBatchUpdatePriceHistory {
  id: number;
  fileName: string;
  status: {
    idStatus: string;
    label: string;
  };
  integrationDate: string;
  utCode: string;
  idTvChannel: number;
  reportName?: string;
}

export class BatchUpdatePriceHistory {
  id: number;
  fileName: string;
  integrationDate: Date | null;
  ut: string;
  step: {
    idStatus: string;
    label: string;
  };
  idTvChannel: number;
  reportDownloadLink?: string;

  constructor(json: JsonBatchUpdatePriceHistory = null) {
    this.id = json.id;
    this.fileName = json.fileName;
    this.integrationDate = createDateFrom(json.integrationDate);
    this.ut = json.utCode;
    this.step = {
      idStatus: json.status?.idStatus,
      label: json.status?.label,
    };
    this.idTvChannel = json.idTvChannel;
    this.reportDownloadLink = json?.reportName;
  }
}
